module.exports = __webpack_public_path__ + "static/media/driver.3bc50e18.png";